import React, { useState, memo, useEffect } from "react";
import { useAppSelector } from "hooks/redux";
import Tables from "components/TableViewMods";
import { MockTitle, TitleInput, Wrapper } from "./quotesPageStyles";
import { showModal } from "store/reducers/modal";
import { useDispatch } from "react-redux";
import { useDragContext } from "components/drag";
import tablesSortWrapper from "../../utils/sortWorkspaces";
import { useTimer } from "use-timer";

const QuotesPage = () => {
    const dispatch = useDispatch();
    const activePage = useAppSelector((state) => state.quotesPage.activePage);
    const { workspaces, currentTab, tabs } = useAppSelector(
        (state) => state.tabs
    );
    const available_tickers = useAppSelector(
        (state) => state.quotes.available_tickers_persistent
    );
    const grid = useAppSelector((state) => state.quotes.grid);
    const order = useAppSelector((state) => state.quotes.order);
    const are_you_sure_modal_state = useAppSelector(
        (state) => state.modals.modals.are_you_sure
    );

    const {
        state: { items },
    } = useDragContext();

    const [state, setState] = useState<{
        workspaces: any[];
        currentTab: any;
        name: string;
        _initial_workspace_fetch_done: boolean;
    }>({
        workspaces: [],
        currentTab: {},
        name: activePage?.name || "",
        _initial_workspace_fetch_done: false,
    });

    // Without this timer we have situtation where 2 actions
    // dispatched at the same time: one triggered by onBlur event
    // and another one triggered by onEnter click
    const { start } = useTimer({
        onTimeOver: titleBlurTimer,
        endTime: 100,
        interval: 100,
        step: 100,
    });

    useEffect(() => {
        if (!activePage || !activePage.id) return;
        setState((s) => ({
            ...s,
            name: "",
        }));
    }, [activePage?.id]);

    function titleBlurTimer() {
        if (!are_you_sure_modal_state) {
            if (
                typeof state.name === "string" &&
                state.name.length &&
                state.name !== activePage?.name
            ) {
                dispatch(
                    showModal({
                        modal_type: "are_you_sure",
                        value: true,
                        caller: activePage?.id,
                        args: {
                            title: "Вы точно хотите отменить изменения?",
                            action: "cancel_rename",
                        },
                    })
                );
            }
        }
    }

    const handleTabTitleBlur = () => {
        start();
    };

    const openAddTickers = (id: any) => {
        dispatch(
            showModal({
                modal_type: "ticker_picker",
                value: true,
                caller: id,
            })
        );
    };

    const handleTabTitleKeyPress = (
        e: KeyboardEvent & { target: HTMLInputElement }
    ) => {
        if (e.key === "Enter") {
            const value = e.target.value;

            unfocusInput();

            dispatch(
                showModal({
                    modal_type: "are_you_sure",
                    value: true,
                    caller: activePage?.id,
                    args: {
                        title: "Вы точно хотите переименовать вкладку?",
                        action: "rename_tab",
                        new_name: value,
                        tab_id: activePage?.id,
                    },
                })
            );
        }
    };

    useEffect(() => {
        if (activePage?.name !== state?.name) {
            setState((p) => ({
                ...p,
                name: activePage?.name,
            }));
        }
    }, [tabs]);

    function filterWorkspaceParams(workspaces: any[]) {
        return workspaces.slice().map((workspace) => ({
            ...workspace,
            params: workspace.params.filter((param) =>
                available_tickers.includes(param.Name)
            ),
        }));
    }

    const FILTERED_TICKERS = workspaces.slice().map((w) => {
        return {
            id: w.id,
            params: w.params.filter((p) => !available_tickers.includes(p.Name)),
        };
    });

    function unfocusInput() {
        const input = document.createElement("input");
        document.body.appendChild(input);
        input.focus();
        document.body.removeChild(input);
    }

    function showTickers(workspaces: any[]) {
        for (const w of workspaces) {
            console.log(
                `FILTERED_TICKERS | workspace_id: ${w.id}`,
                w.params.map((p) => p.Name)
            );
        }
    }

    //showTickers(FILTERED_TICKERS);

    const filtered_workspaces = tablesSortWrapper(
        workspaces.slice(),
        items.map((item) => parseInt(item.id))
    );

    const input_id = `title_input_${activePage?.id}`;

    return (
        <>
            <Wrapper>
                {activePage?.name ? (
                    <TitleInput
                        id={input_id}
                        value={
                            state.name || activePage?.name || "Выберите вкладку"
                        }
                        onBlur={handleTabTitleBlur}
                        onChange={(e) =>
                            setState((p) => ({
                                ...p,
                                name: e.target.value,
                            }))
                        }
                        // @ts-ignore
                        onKeyPress={handleTabTitleKeyPress}
                    />
                ) : (
                    <MockTitle>Выберите вкладку</MockTitle>
                )}
                {activePage && activePage.id && workspaces.length > 0 ? (
                    <Tables
                        workspaces={filtered_workspaces}
                        activePage={activePage}
                        openAddTickers={openAddTickers}
                        currentTab={currentTab}
                        grid={grid}
                        order={order}
                    />
                ) : (
                    <></>
                )}
            </Wrapper>
        </>
    );
};

export default QuotesPage;
